"use strict";

var hex = require("./hex");
var unfix = require("./unfix");

function unfixSigned(n, encoding) {
  return unfix(hex(n, true), encoding);
}

module.exports = unfixSigned;



//////////////////
// WEBPACK FOOTER
// ./node_modules/speedomatic/src/unfix-signed.js
// module id = 497
// module chunks = 146